import React from 'react';
import { motion } from 'framer-motion';
import GBPCollection from './methods/GBPCollection';
import FreebusinessCollection from './methods/FreebusinessCollection';
import WebscrapeCollection from './methods/WebscrapeCollection';

const DataCollectionMethods = ({ currentProject, onDataImported }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <GBPCollection 
          currentProject={currentProject}
          onDataImported={onDataImported}
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <FreebusinessCollection 
          currentProject={currentProject}
          onDataImported={onDataImported}
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
      >
        <WebscrapeCollection 
          currentProject={currentProject}
          onDataImported={onDataImported}
        />
      </motion.div>
    </div>
  );
};

export default DataCollectionMethods;